import { TitleFieldProps } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';
import { Templates } from '@rjsf/bootstrap-4';
export function TitleFieldTemplate({ title, ...props }: TitleFieldProps) {
  return (
    /* @ts-ignore */
    <Templates.TitleFieldTemplate
      {...props}
      title={<MarkdownContent>{title}</MarkdownContent>}
    />
  );
}
